<div *ngIf="sourceResolved" class="square-container border p-2 d-flex flex-column">
  <div style="font-size: 0.75rem" class="mx-2">
    <ul class="list list-unstyled mb-0">

      <li *ngIf="sourceResolved?.name" class="text-nowrap  principle-row-padding">
        <span class="text-primary"> <strong>Resolved source name </strong> </span>
      </li>
      <li *ngIf="sourceResolved?.name" class="text-nowrap secondary-row-padding">
        {{sourceResolved?.name}}
      </li>

      <li *ngIf="sourceResolved?.jPos" class="text-nowrap  principle-row-padding">
        <span class="text-primary"> <strong>Coordinates (RA Dec) </strong> </span>
      </li>
      <li *ngIf="sourceResolved?.jPos" class="text-nowrap secondary-row-padding">
        {{sourceResolved?.jPos}}
      </li>

      <li *ngIf="sourceResolved?.oType" class="text-nowrap principle-row-padding">
        <span class="text-primary"> <strong>Object type </strong> </span>
      </li>
      <li *ngIf="sourceResolved?.oType" class="text-nowrap secondary-row-padding">
        {{sourceResolved?.oType}}
      </li>

      <li *ngIf="sourceResolved?.mType" class="text-nowrap principle-row-padding">
        <span class="text-primary"> <strong>Morphology type </strong> </span>
      </li>
      <li *ngIf="sourceResolved?.mType" class="text-nowrap secondary-row-padding">
        {{sourceResolved?.mType}}
      </li>

      <li>
        <ng-container [ngSwitch]="sourceResolved?.resolver[0]">
          <ng-container *ngSwitchCase="'S'">
            <li class="text-primary principle-row-padding">
              <strong>Resolved by </strong> 
              <img id="Simbad_logo_file" class="py-1 me-1" src="assets/images/simbad.png" alt="Simbad logo">
            </li>
            <li class="text-nowrap secondary-row-padding">
              <a [href]='getSimbadUrl()' target="_blank"> {{sourceResolved?.resolver}} <i class="fa fa-light fa-external-link ms-1"></i> </a>
            </li>
          </ng-container>
          <ng-container *ngSwitchCase="'N'">
            <li class="text-primary principle-row-padding">
              <strong>Resolved by </strong> 
              <img id="Ned_logo_file" class="py-1 me-1" src="assets/images/ned.png" alt="Ned logo">
            </li>
            <li class="text-nowrap secondary-row-padding">
              <a [href]='getNedUrl()' target="_blank"> {{sourceResolved?.resolver}} <i class="fa fa-light fa-external-link ms-1"></i> </a>
            </li>
          </ng-container>
          <ng-container *ngSwitchCase="'V'">
            <li class="text-primary principle-row-padding">
              <strong>Resolved by </strong> 
              <img id="VizieR_logo_file" class="py-1 me-1" src="assets/images/vizier.png" alt="VizieR logo">
            </li>
            <li class="text-nowrap secondary-row-padding">
              <a [href]='getVizierUrl()' target="_blank"> {{sourceResolved?.resolver}} <i class="fa fa-light fa-external-link ms-1"></i></a>
            </li>
          </ng-container>
        </ng-container>
      </li>
      <li *ngIf="sourceResolved?.radius" class="text-nowrap principle-row-padding">
        <span class="text-primary"> <strong>Search radius </strong> </span>
      </li>
      <li *ngIf="sourceResolved?.radius" class="text-nowrap secondary-row-padding">
        {{sourceResolved?.radius}}
      </li>
    </ul>
  </div>
</div>
